import { _ as a } from "./index.es284.js";
import { _ as m } from "./index.es94.js";
import { i as y } from "./index.es265.js";
import { i as f } from "./index.es412.js";
var i = a, p = m, b = y, S = f, _ = 1 / 0, t = i ? i.prototype : void 0, n = t ? t.toString : void 0;
function s(r) {
  if (typeof r == "string")
    return r;
  if (b(r))
    return p(r, s) + "";
  if (S(r))
    return n ? n.call(r) : "";
  var o = r + "";
  return o == "0" && 1 / r == -_ ? "-0" : o;
}
var I = s;
export {
  I as _
};
//# sourceMappingURL=index.es414.js.map
